import ProductGalleryCardAnchor from './ProductGalleryCardAnchor';

export { ProductGalleryCardAnchor };
export { default } from './ProductGalleryCard';
export * from './ProductGalleryCard';
